export default __webpack_public_path__ + "static/media/gas-main-meter-icon.08558f0a.svg";